import template from './synonym-form.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-synonym-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.modalTitleAdd')
                : this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.modalTitleEdit');
        },

        boostOptions() {
            return [
                { value: 'NONE', label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.boostNone') },
                { value: 'LOW', label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.boostLow') },
                { value: 'MEDIUM', label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.boostMedium') },
                { value: 'HIGH', label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.boostHigh') },
            ];
        },

        languageOptions() {
            return [{
                value: null,
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.placeholderLanguage'),
            }, {
                value: 'de',
                label: 'Deutsch',
            }, {
                value: 'en',
                label: 'English',
            }, {
                value: 'fr',
                label: 'Français',
            }];
        },
    },

    methods: {
        getLanguageLabel(languageId: string | null): string {
            if (!languageId) {
                return this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.languageGlobal');
            }
            const labels: Record<string, string> = {
                'de': 'Deutsch',
                'en': 'English',
                'fr': 'Français',
            };
            return labels[languageId] || languageId;
        },

        onSave() {
            if (!this.entity.term.trim() || !this.entity.synonyms.trim()) {
                return;
            }

            this.isLoading = true;

            const criteria = new Criteria(1, 1);
            criteria.addFilter(Criteria.equals('term', this.entity.term.trim()));
            criteria.addFilter(
                this.entity.languageId
                    ? Criteria.equals('languageId', this.entity.languageId)
                    : Criteria.equals('languageId', null),
            );

            this.repository.search(criteria).then((result) => {
                const conflict = result.find((candidate) => candidate.id !== this.entity.id);

                if (conflict) {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$t('TopdataEnhancedSearchSW6.topdata-es-synonym.duplicateTermLanguage', {
                            term: this.entity.term.trim(),
                            language: this.getLanguageLabel(this.entity.languageId),
                        }),
                    });
                    return;
                }

                this.repository.save(this.entity).then(() => {
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.saveSuccess'),
                    });
                    this.$emit('save', this.entity);
                }).catch(() => {
                    this.isLoading = false;
                });
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});
